export default "__VITE_ASSET__DerrfPg9__"